const e = "data:image/svg+xml,%3csvg%20viewBox='0%200%2030%2030'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='30'%20height='30'%20rx='4'%20fill='%231D66BF'/%3e%3cpath%20d='M5.75%2015.9705L11.25%2022.9705'%20stroke='white'%20stroke-width='3'%20stroke-linecap='round'/%3e%3cpath%20d='M11.2502%2022.9705L26.0994%207.99998'%20stroke='white'%20stroke-width='3'%20stroke-linecap='round'/%3e%3c/svg%3e";
export {
  e as default
};
//# sourceMappingURL=icon-checked.svg.js.map
